export const NAV_USER_ICON_POPOVER_SHOWN = "navUserIconPopoverShown";

export const HOME_MATCH_PREFERENCES_MODAL_DISMISSED = "homeMatchPreferencesModalDismissed";
export const PHONE_NUMBER_MODAL_DISMISSED = "phoneNumberModalDismissed";
export const NAV_USER_ICON_POPOVER_SHOWN = "navUserIconPopoverShown";

export const HOME_MATCH_PREFERENCES_MODAL_DISMISSED = "homeMatchPreferencesModalDismissed";
export const PHONE_NUMBER_MODAL_DISMISSED = "phoneNumberModalDismissed";
